export const linkRegex = '^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?';
export const linkRegexr = new RegExp(linkRegex, 'i');

export const phoneRegex = '\\+1(\\d{10})';
export const phoneRegexr = new RegExp(`^${phoneRegex}$`, 'i');

export const usernameRegex = '[-._a-zA-Z0-9]{3,36}';
export const usernameRegexr = new RegExp(`^${usernameRegex}$`, 'i');
